import { Button } from "@peer-start/ui/reducate";
import { CircleHelp, RotateCcw } from "lucide-react";
import { useLayoutEffect, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";

export function StartingTeacherResetButton({ onReset }: { onReset: () => void }) {
  const { t } = useTranslation();
  return (
    <Button controlId="learning-route.reset" onClick={onReset} type="button" variant="secondary">
      <RotateCcw aria-hidden="true" className="size-4" />
      {t("startingTeacher.reset")}
    </Button>
  );
}

export function StartingTeacherRouteActions({
  onReset,
  onStartTour,
}: {
  onReset: () => void;
  onStartTour: () => void;
}) {
  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      <StartingTeacherResetButton onReset={onReset} />
      <StartingTeacherTourButton onStartTour={onStartTour} />
    </div>
  );
}

export function StartingTeacherTourButton({ onStartTour }: { onStartTour: () => void }) {
  const { t } = useTranslation();
  return (
    <Button
      aria-label={t("productTour.restart")}
      className="size-6 h-6 min-h-0 w-6 p-0 text-muted-foreground"
      controlId="learning-route.tour.start"
      onClick={onStartTour}
      type="button"
      variant="ghost"
    >
      <CircleHelp aria-hidden="true" className="size-[18px]" />
    </Button>
  );
}

/** Places reset and the tour control in the breadcrumb bar when that slot exists. */
export function LearningRouteToolbar({
  onReset,
  onStartTour,
}: {
  onReset: () => void;
  onStartTour: () => void;
}) {
  const [host, setHost] = useState<HTMLElement | null>(null);
  const [ready, setReady] = useState(false);
  useLayoutEffect(() => {
    setHost(document.getElementById("learning-route-toolbar"));
    setReady(true);
  }, []);
  if (!ready) return null;
  const actions: ReactNode = (
    <StartingTeacherRouteActions onReset={onReset} onStartTour={onStartTour} />
  );
  return host ? createPortal(actions, host) : actions;
}
